import router from "@/router";
import {getValue} from "@/globalFunctions";
import {UserModule} from "@/store/modules/user";
import {LicenseModule} from "@/store/modules/license";
import {continueCheckout} from "@/data/api/stripe";

export const filters = [{
        field: "sort",
        clearable: true,
        options: [
            { label: 'table.order.id-asc', key: 'Id-asc' },
            { label: 'table.order.id-desc', key: 'Id-desc' },
            { label: 'table.order.company-asc', key: 'Company.Name-asc' },
            { label: 'table.order.company-desc', key: 'Company.Name-desc' },
            { label: 'table.order.start-date-asc', key: 'Subscription.StartDate-asc' },
            { label: 'table.order.start-date-desc', key: 'Subscription.StartDate-desc' },
            { label: 'table.order.end-date-asc', key: 'Subscription.EndDate-asc' },
            { label: 'table.order.end-date-desc', key: 'Subscription.EndDate-desc' },
        ],
        placeholder: 'table.sort'
    }
];

export const columns = [
    {
        label: 'table.status',
        field: "DefaultLicense",
        translate: true,
        formatter: (x : any) => {
            return (x ? 'table.active' : 'table.inactive');
        },
        tag: true,
        tagType: (x : any) => {
            return (x ? 'success' : 'danger')
        }
    },
    {
        label: 'table.payment-status',
        field: "PaymentStatus",
        translate: true,
        formatter: (x : any) => {
            return (x === "paid" ? 'table.paid' : (x === "trial" ? "table.trial" : "table.unpaid"));
        },
        tag: true,
        tagType: (x : any) => {
            return (x === "paid" ? 'success' : (x === "trial" ? "info" : "danger"))
        }
    },
    {
        label: 'table.license-name',
        field: "LicenseName",
    },
    {
        label: 'table.scans',
        field: 'Scans',
        formatter: (x : any) => {
            return x.Total + "/" + x.GeneralMaximum;
        }
    }
];

export const actions = [
    {
        label: 'table.switch-license',
        icon: "login",
        type: 'primary',
        condition: (row: any) => {
            return row.Id !== UserModule.user.DefaultLicense;
        },
        click: (row : any) => {
            window.GlobalEvents.$emit("start-list-load");
            UserModule.SetDefaultLicense(row.Id);
        }
    },
    // TODO: Fix upgrade function
    // {
    //     label: 'table.upgrade',
    //     icon: "upgrade",
    //     type: 'warning',
    //     condition: (row: any, index?: number) => {
    //         return row.Subscription.Type === "one-time";
    //     },
    //     click: (row : any, index : number) => {
    //         console.log(row);
    //         window.open(row?.Invoice?.Url, "_blank");
    //     }
    // },
    {
        label: 'table.pay',
        icon: "storefront",
        type: 'warning',
        condition: (row: any) => {
            return row.PaymentStatus !== "paid";
        },
        click: (row : any) => {
            window.GlobalEvents.$emit("start-list-load");
            continueCheckout(row.Id).then((result) => {
                window.open(result.data.Url, "_self");
            })
        }
    },
    {
        label: 'table.info',
        icon: "info",
        type: 'info',
        condition: (row: any) => {
            return row.Products?.length > 0;
        },
        click: (row : any) => {
            return router.push("/user/licenses/" + row.Id);
        }
    }
];

export const getData = async (listQuery : any) => {
    // Get items
    if (!LicenseModule.list._retrieved || LicenseModule.list._admin){
        await LicenseModule.list.get()
    }

    let items = LicenseModule.list.toList().map((item: any) => {
        return {
            ...item,
            DefaultLicense: UserModule.license === item.Id
        }
    });

    // Sort
    if (listQuery.sort){
        const [field, order] = listQuery.sort.split("-")
        items = items.sort((a: any, b: any) => {
            if(getValue(a, field) < getValue(b, field)) { return order === 'asc' ? -1 : 1; }
            if(getValue(a, field) > getValue(b, field)) { return order === 'asc' ? 1 : -1; }
            return 0;
        });
    }

    return {
        data: {
            items: items,
            total: items.length
        }
    };
};
